import React, { useEffect, useState, useRef, useContext } from "react";
import { firestore, auth, functions } from "../firebase/firebase";
// import firebase from "../firebase";
// import firebase from 'firebase/app';

import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import CircularProgress from "@material-ui/core/CircularProgress";
import Paper from "@material-ui/core/Paper";
import FormGroup from "@material-ui/core/FormGroup";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import SaveIcon from "@material-ui/icons/Save";
import DeleteIcon from "@material-ui/icons/Delete";
import SendIcon from "@material-ui/icons/Send";
import AlertDialog from "./AlertDialog";

import {
    // BrowserRouter as Router,
    // Switch as RouterSwitch,
    // Route,
    // Link,
    useParams,
    useHistory,
} from "react-router-dom";

import { UserContext } from "../providers/UserProvider";



function AdminUser(props) {
    const { user } = useContext(UserContext);

    const [adminUser, setAdminUser] = useState(null);

    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [department, setDepartment] = useState("");
    const [accessLevel, setAccessLevel] = useState(30);

    const [isSaving, setIsSaving] = useState(false);
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [resetDialogOpen, setResetDialogOpen] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);

    const [open, setOpen] = useState(false);
    const [openDidSendResetSnackbar, setOpenDidSendResetSnackbar] = useState(false);
    const [openDidDeleteSnackbar, setOpenDidDeleteSnackbar] = useState(false);
    const [openDidDeleteSnackbarError, setOpenDidDeleteSnackbarError] =
        useState(false);

    let history = useHistory();

    let { userId } = useParams();
    const adminUserId = useRef(userId);
    let unsubsribeFromUserDoc = useRef(null);

    const [isNewMember, setIsNewMember] = useState(true);

    const permissionRoles = [
        {
            title: "Owner",
            value: 10,
        },
        {
            title: "Admin",
            value: 20,
        },
        {
            title: "Editor",
            value: 30,
        },
    ];

    const handleClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setOpen(false);
    };

    const handleCloseDidSendResetSnackbar = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setOpenDidSendResetSnackbar(false);
    };

    const handleCloseDidDeleteSnackbar = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setOpenDidDeleteSnackbar(false);
        history.push("/admin-anvandare/");
    };

    const handleCloseDidDeleteSnackbarError = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setOpenDidDeleteSnackbarError(false);
    };

    useEffect(() => {
        if (adminUserId.current === "ny") {
            setAdminUser({
                id: "1",
            });
        }
        if (adminUserId.current !== "ny") {
            setIsNewMember(false);

            const userRef = firestore.doc(`adminUsers/${adminUserId.current}`);

            const getCurrentValues = async () => {
                try {
                    const userSnapshot = await userRef.get();

                    if (userSnapshot.exists) {
                        const userDoc = userSnapshot.data();
                        userDoc.firstName && setFirstName(userDoc.firstName);
                        userDoc.lastName && setLastName(userDoc.lastName);
                        userDoc.accessLevel && setAccessLevel(userDoc.accessLevel);
                        userDoc.email && setEmail(userDoc.email);
                        userDoc.department && setDepartment(userDoc.department);
                    }
                } catch (error) {
                    console.error(error);
                }
            };

            getCurrentValues();

            return () => { };
        }
    }, []);

    useEffect(() => {
        if (isNewMember === false) {
            const userRef = firestore.doc(`adminUsers/${adminUserId.current}`);
            unsubsribeFromUserDoc.current = userRef.onSnapshot((userSnapshot) => {
                if (userSnapshot.exists) {
                    const data = userSnapshot.data();
                    setAdminUser(data);
                }
            });

            return () => {
                unsubsribeFromUserDoc.current();
            };
        } else {
            if (unsubsribeFromUserDoc.current !== null) {
                unsubsribeFromUserDoc.current();
            }
        }
    }, [isNewMember]);

    const handleFirstNameChange = (event) => {
        const name = event.target.value;
        setFirstName(name);
    };

    const handleLastNameChange = (event) => {
        const name = event.target.value;
        setLastName(name);
    };

    const handleDepartmentChange = (event) => {
        const department = event.target.value;
        setDepartment(department);
    };

    const handleAccessLevelChange = (event) => {
        // console.log(event.target.value);
        setAccessLevel(event.target.value);
    };

    const handleEmailChange = (event) => {
        setEmail(event.target.value);
    };

    const handlePasswordChange = (event) => {
        setPassword(event.target.value);
    };

    const canSave = async () => {
        let allowed = true;
        // if (
        //     !onValidatePersonalId()
        //     || !onValidateLmaNumber()
        //     || !onValidateBirthDate()
        // ) {
        //     allowed = false;
        // }
        return allowed;
    };

    const onCancel = async () => {
        history.push("/admin-anvandare/");
    };

    const onSendPasswordResetEmail = async () => {
        try {
            await auth.sendPasswordResetEmail(email);
            setOpenDidSendResetSnackbar(true);
        } catch (error) {
            console.error("Could not send password reset email. ", error);
            alert("Kunde inte skicka mejl.");
        }
    };


    const onDeleteAccount = async () => {
        setIsDeleting(true);
        try {
            await functions.httpsCallable("deleteAdminUser")({
                id: adminUserId.current,
            });
            setOpenDidDeleteSnackbar(true);
        } catch (error) {
            console.error("Could not delete account", error);
            setOpenDidDeleteSnackbarError(true);
        }
        setIsDeleting(false);
    };

    const onSave = async () => {
        setIsSaving(true);

        if (await canSave()) {
            try {
                let saveResponse = null;
                if (isNewMember) {
                    // console.log(accessLevel);
                    saveResponse = await functions.httpsCallable("addAdminUser")({
                        firstName,
                        lastName,
                        email,
                        password,
                        department,
                        accessLevel,
                    });
                } else {
                    saveResponse = await functions.httpsCallable("updateAdminUser")({
                        id: adminUser.id,
                        firstName,
                        lastName,
                        department,
                        accessLevel,
                    });
                }
                // console.log(saveResponse);
                if (saveResponse.data !== null && saveResponse.data.error) {
                    alert(saveResponse.data.error);
                }
                if (saveResponse.data !== null && !saveResponse.data.error) {
                    setOpen(true);
                    if (isNewMember === true) {
                        if (typeof saveResponse.data.id === "string") {
                            adminUserId.current = saveResponse.data.id;
                            setAdminUser({
                                ...adminUser,
                                id: saveResponse.data.id,
                            });
                            history.push("/admin-anvandare/" + saveResponse.data.id);
                        }
                        setIsNewMember(false);
                    }
                }
            } catch (error) {
                console.error("Could not save admin user. ", error.message);
                if (error.code === 'invalid-argument') {
                    alert(error.message);
                }
                if (error.code === 'already-exists') {
                    alert(error.message);
                }
            }
        }

        setIsSaving(false);
    };

    const classes = useStyles();

    return (
        <React.Fragment>

            <Snackbar
                open={open}
                autoHideDuration={2000}
                onClose={handleClose}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                style={{ marginLeft: 100, marginTop: 50 }}
            >
                <Alert onClose={handleClose} severity="success">
                    Ändringar sparade!
                </Alert>
            </Snackbar>

            <Snackbar
                open={openDidSendResetSnackbar}
                autoHideDuration={2000}
                onClose={handleCloseDidSendResetSnackbar}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                style={{ marginLeft: 100, marginTop: 50 }}
            >
                <Alert onClose={handleCloseDidSendResetSnackbar} severity="success">
                    Mejl med återställningslänk har skickats!
                </Alert>
            </Snackbar>

            <Snackbar
                open={openDidDeleteSnackbar}
                autoHideDuration={2000}
                onClose={handleCloseDidDeleteSnackbar}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                style={{ marginLeft: 100, marginTop: 50 }}
            >
                <Alert
                    onClose={handleCloseDidDeleteSnackbar}
                    severity="success"
                >
                    Kontot raderat!
                </Alert>
            </Snackbar>

            <Snackbar
                open={openDidDeleteSnackbarError}
                autoHideDuration={2000}
                onClose={handleCloseDidDeleteSnackbarError}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                style={{ marginLeft: 100, marginTop: 50 }}
            >
                <Alert
                    onClose={handleCloseDidDeleteSnackbarError}
                    severity="error"
                >
                    Kunde inte radera kontot!
                </Alert>
            </Snackbar>

            {user && (
                <>
                    <form
                        className={classes.root}
                        noValidate
                        autoComplete="off"
                    >
                        <Grid container className={classes.root} spacing={2}>
                            <Grid item xs={7}>
                                <Paper className={classes.paper}>
                                    <FormGroup>
                                        <TextField
                                            onChange={handleFirstNameChange}
                                            value={firstName}
                                            label="Förnamn"
                                            variant="outlined"
                                            style={{ marginTop: 0 }}
                                        />
                                        <TextField
                                            onChange={handleLastNameChange}
                                            value={lastName}
                                            label="Efternamn"
                                            variant="outlined"
                                            style={{ marginTop: 30 }}
                                        />
                                        <TextField
                                            onChange={handleEmailChange}
                                            value={email}
                                            label="E-post"
                                            variant="outlined"
                                            disabled={!isNewMember}
                                            style={{
                                                marginTop: 30,
                                                marginBottom: !isNewMember ? 30 : 0,
                                            }}
                                        />
                                        {isNewMember &&
                                            <TextField
                                                onChange={handlePasswordChange}
                                                value={password}
                                                label="Lösenord"
                                                variant="outlined"
                                                style={{
                                                    marginTop: 30,
                                                    marginBottom: 30,
                                                }}
                                            />
                                        }
                                        <TextField
                                            onChange={handleDepartmentChange}
                                            value={department}
                                            label="Avdelning"
                                            variant="outlined"
                                            style={{
                                                marginBottom: 30,
                                            }}
                                        />

                                        <FormControl
                                            variant="outlined"
                                            className={classes.formControl}
                                        >
                                            <InputLabel id="district">
                                                Accessnivå
                                            </InputLabel>

                                            <Select
                                                labelId="district"
                                                id="demo-simple-select"
                                                style={{ marginBottom: 30 }}
                                                value={accessLevel}
                                                onChange={handleAccessLevelChange}
                                                label="Accessnivå"
                                                disabled={!adminUser || !user || adminUser?.id === user?.id}
                                            >
                                                {permissionRoles.map((role) => {
                                                    return (
                                                        <MenuItem
                                                            value={role.value}
                                                            key={role.title}
                                                        >
                                                            {role.title}
                                                        </MenuItem>
                                                    );
                                                })}
                                            </Select>
                                        </FormControl>


                                        <div
                                            style={{
                                                display: "flex",
                                                flexDirection: "row",
                                                alignItems: "left",
                                                justifyContent: "left",
                                                marginBottom: 10,
                                            }}
                                        >
                                            <Button
                                                variant="outlined"
                                                color="primary"
                                                style={{
                                                    marginRight: 20,
                                                    width: 150,
                                                }}
                                                onClick={onCancel}
                                                disabled={!canSave}
                                            >
                                                Stäng
                                            </Button>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                style={{ width: 150 }}
                                                onClick={onSave}
                                                disabled={!canSave}
                                                startIcon={<SaveIcon />}
                                            >
                                                Spara
                                            </Button>
                                            {isSaving && (
                                                <CircularProgress
                                                    size={20}
                                                    style={{
                                                        position: "relative",
                                                        left: 10,
                                                        top: 7,
                                                    }}
                                                />
                                            )}
                                        </div>
                                    </FormGroup>
                                </Paper>
                            </Grid>
                            <Grid item xs={5}>
                                {!isNewMember &&
                                    <>
                                        <Button
                                            variant='outlined'
                                            color='primary'
                                            style={{ marginTop: 40 }}
                                            startIcon={<SendIcon />}
                                            onClick={() => setResetDialogOpen(true)}
                                        >
                                            Återställ lösenord
                                        </Button><br />
                                        <Button
                                            variant='outlined'
                                            color='secondary'
                                            style={{ marginTop: 40 }}
                                            startIcon={<DeleteIcon />}
                                            onClick={() => setDeleteDialogOpen(true)}
                                            disabled={!adminUser || !user || adminUser?.id === user?.id}
                                        >
                                            Radera admin-användare
                                        </Button>
                                    </>
                                }
                                {isDeleting &&
                                    <CircularProgress
                                        size={20}
                                        style={{ position: 'relative', left: 10, top: 25 }}
                                    />
                                }
                            </Grid>
                        </Grid>
                    </form>

                    <AlertDialog
                        title="Återställ lösenord"
                        description={"Skicka ett e-postmeddelande om återställning av lösenord till " + email}
                        confirm={onSendPasswordResetEmail}
                        open={resetDialogOpen}
                        setOpen={setResetDialogOpen}
                        confirmButtonColor="primary"
                        confirmButtonTitle="Skicka"
                    />

                    <AlertDialog
                        title="Radera admin-användare?"
                        description=""
                        confirm={onDeleteAccount}
                        open={deleteDialogOpen}
                        setOpen={setDeleteDialogOpen}
                        confirmButtonColor="secondary"
                        confirmButtonTitle="Radera"
                    />
                </>
            )}
        </React.Fragment>
    );
}

export default AdminUser;


const useStyles = makeStyles((theme) => ({
    seeMore: {
        marginTop: theme.spacing(3),
        table: {
            minWidth: 650,
        },
    },
    formControl: {
        marginBottom: 30,
        textAlign: "left",
    },
    paper: {
        padding: theme.spacing(2),
        display: "flex",
        overflow: "auto",
        flexDirection: "column",
    },
    avatar: {
        width: theme.spacing(40),
        height: theme.spacing(40),
        margin: "0 auto",
    },
}));

// function Alert(props) {
//     return <MuiAlert elevation={6} variant="filled" {...props} />;
// }
